"use client";
import { jsx, jsxs } from "react/jsx-runtime";

import React, { forwardRef, useRef, useState, useEffect } from "react";
import cx from "classnames";
import SSRIcon from "@ingka/ssr-icon";
import searchIcon from "@ingka/ssr-icon/paths/magnifying-glass";
import { SearchScope } from "./elements/SearchScope.mjs";
import { ClearButton } from "./elements/ClearButton.mjs";
import { Actions } from "./elements/Actions.mjs";
import { SearchButton } from "./elements/SearchButton.mjs";
const Search = forwardRef((props, ref) => {
  const {
    actions,
    ariaLabel,
    className,
    clearBtnText,
    submitBtnText,
    describedById,
    disabled,
    id,
    onSearch,
    onClear,
    onChange,
    onKeyDown,
    prefix = "",
    placeholder = "Search",
    scope,
    scopeSelectProps,
    ...other
  } = props;
  const { defaultValue, value } = other;
  const [isFilled, setIsFilled] = useState(Boolean(defaultValue || value));
  const inputRef = ref || useRef(null);
  const selectRef = useRef(null);
  const getState = () => ({
    scope: selectRef.current && selectRef.current.value,
    value: inputRef.current.value
  });
  const handleValueChange = (e) => {
    setIsFilled(Boolean(e.target.value.length));
    if (onChange)
      onChange(e, getState());
  };
  const handleClearValue = (e) => {
    if (!value || value.length < 1) {
      inputRef.current.value = "";
      setIsFilled(false);
    }
    inputRef.current.focus();
    if (onClear)
      onClear(e);
  };
  const handleSearch = (e) => {
    if (onSearch)
      onSearch(e, getState());
  };
  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e, getState());
    }
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };
  useEffect(() => {
    setIsFilled(!!inputRef.current.value);
  }, [value]);
  const baseClass = `${prefix}search`;
  const searchClasses = cx(
    `${baseClass}`,
    isFilled && `${baseClass}--filled`,
    disabled && `${baseClass}--disabled`,
    className
  );
  return /* @__PURE__ */ jsxs("div", { className: searchClasses, children: [
    /* @__PURE__ */ jsx(
      SSRIcon,
      {
        prefix,
        paths: searchIcon,
        className: `${baseClass}__icon`
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        id,
        ref: inputRef,
        type: "search",
        className: `${baseClass}__input`,
        disabled,
        onChange: handleValueChange,
        onKeyDown: handleKeyDown,
        placeholder,
        "aria-disabled": disabled,
        "aria-describedby": describedById,
        "aria-label": ariaLabel,
        ...other
      }
    ),
    /* @__PURE__ */ jsx(
      ClearButton,
      {
        baseClass,
        prefix,
        clearBtnText,
        onClick: handleClearValue,
        hidden: !isFilled
      }
    ),
    /* @__PURE__ */ jsx(
      Actions,
      {
        prefix,
        baseClass,
        actions,
        hidden: isFilled
      }
    ),
    scope && /* @__PURE__ */ jsx(
      SearchScope,
      {
        ref: selectRef,
        prefix,
        options: scope,
        selectProps: scopeSelectProps
      }
    ),
    /* @__PURE__ */ jsx(
      SearchButton,
      {
        prefix,
        baseClass,
        text: submitBtnText,
        onClick: handleSearch,
        hidden: !isFilled
      }
    )
  ] });
});
Search.displayName = "Search";
var Search_default = Search;
export {
  Search_default as default
};
